import React, { useEffect, useState, useContext } from 'react';
import { isBotAgent } from '../sport-utils';
import { getConfiguration } from '../utils/configuration';
import { SeoContext } from './SeoContextProvider';
import { useHandleSeoHtml } from './seoUtils';
import SeoBreadcrumb from './SeoBreadcrumb';
import { getEnv } from '../env';

function SeoMainContainer(props) {
    const cfgSeo = getConfiguration().seo;
    const seoContext = useContext(SeoContext);
    const [collapsed, setCollapsed] = useState(!isBotAgent() && !getConfiguration().smce );
      const conf = getConfiguration()


    useHandleSeoHtml(seoContext.pathname,seoContext.location,'seo-main-container');

    function toggleCollapsed(){
        setCollapsed(!collapsed);
    }

    useEffect(function() {
        var target = document.querySelector('#seo-main-container');
        var observer;
        if(target){
            const toggleDisplay = function(el){
                if(!(el.innerText || el.innerHTML)){
                    el.style.display = 'none';
                }else{
                     el.style.display = 'block';
                } 
            }
            toggleDisplay(target);
            observer = new MutationObserver(function(mutations) {
                toggleDisplay(target);      
          });
          var config = { attributes: true, childList: true, characterData: true };
          observer.observe(target, config);
        }

        return () => {
            if(observer){
                observer.disconnect();
            }
        }
        
    }, []);

    const handleCollapse = (event)=>{
        const element = event.target;

    function isClickOnPseudo(pseudo) {
      const style = window.getComputedStyle(element, pseudo);
      let content = style.getPropertyValue("content");

      // Remove surrounding quotes
      content = content.replace(/(^"|"$)/g, "");

      if (content !== "EXPANDSEO") {
        return false;
      }

      return true;
    }

    if (isClickOnPseudo("::after")) {
        toggleCollapsed();
    }
      }

    return (
        cfgSeo && seoContext.pathname?
        <>  
            <div className="xs-seo-content-wrapper">
                <SeoBreadcrumb />
                <div id="seo-main-container" className={`seo-main-container ${collapsed?'':'expanded'} ${seoContext.showHtmlContainer?'':'d-none'} `} onClick={handleCollapse} ></div>
                 {/* TODO da mettere in configurazione */}
                 {(conf.iwh || getEnv('REACT_APP_BETSSON_VERSION') || getEnv('REACT_APP_FRONTEND_VERSION') === 'betsson') &&
                    <div
                        className={`seo-toggler ${seoContext.showHtmlContainer  ? '' : 'd-none'}`}
                        onClick={toggleCollapsed}
                        style={{ cursor: 'pointer', marginTop: '10px', fontWeight: 'bold', display: 'flex', justifyContent: 'center' }}
                    >
                        {collapsed ? 'Mostra di più' : 'Mostra di meno'}
                    </div>
                    }
            </div>
        </>
        
        :
        <></>
    );
}

export default SeoMainContainer;